import { useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment";
import { FC, useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Badge, Button, Modal, Spinner } from "reactstrap";
import DELETE_ICON from "../../assets/images/delete-icon-menu.svg";
import EDIT_ICON from "../../assets/images/edit-icon-menu.svg";
import EMAIL_ICON from "../../assets/images/email-icon.svg";
import VIEW_ICON from "../../assets/images/view-icon.svg";
import SEND_NOW_ICON from "../../assets/images/send-now.svg";
import SCHEDULED_ICON from "../../assets/images/schedule-timer.png";
import ConfirmPopUp from "../../components/ConfirmPopUp";
import GoBack from "../../components/GoBack";
import InputField from "../../components/layout/InputField";
import Loader from "../../components/layout/Loader";
import NoDataFound from "../../components/layout/NoDataFound";
import { Pagination } from "../../components/layout/Pagination";
import TableComponent from "../../components/layout/TableComponent";
import { ACTIVITY_REPORTS_HEADER, SCHEDULED_EMAILS, SCHEDULED_EMAILS_HEADERS, USER_ACTIVITY_REPORT } from "../../constants";
import { ADMIN_ROUTE, COLUMN_INTERFACE_TYPES_FOR_USER_ACTIVITY_REPORT, PAGE_LIMIT } from "../../utils/constant";
import Preview from "../job-order/job-order-components/document-preview/Preview";
import AddActivityReportModal from "./AddActivityReportModal";
import EmailModalActivityReport from "./EmailModalActivityReport";
import { DELETE_RECORD, GET_CC_EMAILS, GET_SIGNED_URL, SEND_SCHEDULE_EMAIL, GET_SCHEDULED_ACTIVITY_REPORTS_EMAILS, SCHEDULED_ACTIVITY_REPORT_EMAIL, GET_USER_ACTIVITY_REPORT, DELETE_SCHEDULED_RECORD } from "./gql";
import { EmailUserActivityReportPayload, IScheduledActivityReportsEmails, IUserActivityReport, UserActivityReportsProps } from "../agreements/interfaces";
import { formatDateUS } from "../../utils/commonFn";

let time = 0

const SendNowButton = ({ variables, refetch, sent }) => {
  const [sendScheduledEmail, { loading }] = useMutation(SEND_SCHEDULE_EMAIL, {
    onCompleted: () => {
      toast.success("sent email successfully")
      refetch()
    },
    onError: () => {
      toast.error('Error While Sending Email')
    }
  })
  return (
    <Button className="bg-transparent border-0 p-0"
      disabled={sent}>
      {loading ? <Spinner className='mx-0' size='sm' style={{ color: "#eaa827" }} /> :
        <img src={SEND_NOW_ICON} onClick={() => {
          sendScheduledEmail({ variables })
        }} alt="send-now" />}
    </Button >
  )
}

const UserActivityReports: FC<UserActivityReportsProps> = ({ recruiterDetailPage, userName }) => {
  const defaultColumnFilters = {
    userSearch: '',
    monthSearch: '',
    yearSearch: '',
    sorting: {
      columnName: '',
      columnValue: '',
    },
  };
  const [getUserActivityReports, { data, loading, refetch }] =
    useLazyQuery(GET_USER_ACTIVITY_REPORT, { onCompleted: (data) => { setReportList(data?.userActivityReports?.userActivityReports) } })

  const [getScheduledActivityReports, {
    data: dataScheduledEmails,
    loading: loadingScheduledEmails, refetch: refetchScheduledEmails }] =
    useLazyQuery(GET_SCHEDULED_ACTIVITY_REPORTS_EMAILS, {
      onCompleted: (data) => { setScheduledEmailsList(data?.scheduledActivityReportEmails?.scheduledActivityReportsEmails) }
    })

  const [getSignedURL] = useLazyQuery(GET_SIGNED_URL);
  const [getCCEmails, { loading: loadingEmail, data: emailData }] = useLazyQuery(GET_CC_EMAILS);

  const [deleteReport, { loading: deleting }] = useMutation(DELETE_RECORD)
  const [deleteScheduledReport, { loading: deletingScheduledReport }] = useMutation(DELETE_SCHEDULED_RECORD, {
    onCompleted: () => {
      toast.success('deleted successfully')
      setConfirmDeletion(!confirmDeletion)
      setDeleteScheduledRecord('')
      refetchScheduledEmails()
    },
    onError: () => {
      toast.error("Error While Deleting")
    }
  })

  const [columnFilters, setColumnFilters] =
    useState<COLUMN_INTERFACE_TYPES_FOR_USER_ACTIVITY_REPORT>(defaultColumnFilters);
  const [currentPage, setCurrentPage] = useState(1);
  const [scheduledCurrentPage, setScheduledCurrentPage] = useState(1);
  const [scheduledLimit, setScheduledLimit] = useState(10);
  const [limit, setLimit] = useState(10);
  const [singleReport, setSingleReport] = useState<{ id: string; month: string; year: string; userId: string, fullName: string; documentLink: string; email?: string }>()
  const [editableBody, setEditableBody] = useState<EmailUserActivityReportPayload>()
  const [addReportModal, setAddReportModal] = useState(false);
  const [reportList, setReportList] = useState<IUserActivityReport[]>([]);
  const [scheduledEmailsList, setScheduledEmailsList] = useState<IScheduledActivityReportsEmails[]>([]);
  const [editAble, setEditAble] = useState(false);
  const [confirmDeletion, setConfirmDeletion] = useState(false);
  const [filtering, setFiltering] = useState<boolean>(false)
  const [deleteScheduledRecord, setDeleteScheduledRecord] = useState<string>()
  const [emailReportModal, setEmailReportModal] = useState<boolean>(false);
  const [viewDocument, setViewDocument] = useState<boolean>()
  const [documentUrl, setDocumentUrl] = useState<string>('')
  const [documentName, setDocumentName] = useState<string>('')
  const { register, setValue } = useForm()
  const getScheduledActivityReportsCallBack = useCallback(async () => {
    if (filtering) {
      window.clearTimeout(time);
      time = window.setTimeout(async () => {
        await getUserActivityReports({
          variables: {
            page: currentPage, limit: limit, columnFilters, recruiterDetailPage: recruiterDetailPage || false
          }
        })
      }, 1000);
    } else {
      await getUserActivityReports({
        variables: {
          page: currentPage, limit: limit, columnFilters, recruiterDetailPage: recruiterDetailPage || false
        }
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, limit, columnFilters])
  useEffect(() => {
    getScheduledActivityReportsCallBack()
  }, [getScheduledActivityReportsCallBack])

  const _getScheduledActivityReports = useCallback(async () => {
    if (filtering) {
      window.clearTimeout(time);
      time = window.setTimeout(async () => {
        await getScheduledActivityReports({
          variables: {
            page: scheduledCurrentPage, limit: scheduledLimit
          }
        })
      }, 1000);
    } else {
      await getScheduledActivityReports({
        variables: {
          page: scheduledCurrentPage, limit: scheduledLimit
        }
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduledCurrentPage, scheduledLimit])
  useEffect(() => {
    _getScheduledActivityReports()
  }, [_getScheduledActivityReports])

  useEffect(() => {
    if (userName) {
      setColumnFilters((prevFilters) => ({
        ...prevFilters,
        userSearch: userName,
      }));
    }
  }, [userName])

  const changeFiled = (fieldName, value) => {
    if (fieldName?.endsWith('Sort')) {
      setFiltering(false)
      const columnName = fieldName.replace('Sort', '');
      setColumnFilters((prevFilters) => {
        const { sorting, ...otherFilters } = prevFilters;
        return {
          ...otherFilters,
          sorting: {
            columnName: columnName,
            columnValue: value ? 'ASC' : 'DESC',
          },
        };
      });
    } else {
      setFiltering(true)
      setColumnFilters((prevFilters) => ({
        ...prevFilters,
        [fieldName]: value,
      }));
    }
    console.log("columnFilter :: ", columnFilters)
  };

  const SignedUrl = useCallback(async (url) => {
    const { data } = await getSignedURL({ variables: { url } })
    const { getSignedUrl } = data || {};
    const { signedUrl } = getSignedUrl || {};
    return signedUrl;
  }, [getSignedURL])

  const viewReport = async (url: string, name: string) => {
    setViewDocument(true)
    setDocumentUrl(await SignedUrl(url))
    setDocumentName(name)
  }


  return (
    <>
      {!recruiterDetailPage &&
        <>
          <GoBack url={ADMIN_ROUTE} />

          <div className='w-100 d-flex justify-content-between align-items-center'>
            <h5 className="m-0">{USER_ACTIVITY_REPORT}</h5>
            <div>
              <button
                onClick={() => setAddReportModal(true)}
                className="buttonGenericStyle filledButton">
                Add New Report
              </button>
            </div>
          </div>
        </>
      }
      <div className="table-responsive mt-3">
        <TableComponent
          advanceSearching={true}
          handleChange={changeFiled}
          register={register}
          setValue={setValue}
          tableHeaderAdvSeacrh={ACTIVITY_REPORTS_HEADER(recruiterDetailPage)}>
          {loading ? (
            <tbody>
              <tr>
                <td colSpan={4}>
                  <Loader loaderClass="sm-height " />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody className='placement-table'>
              {reportList?.length > 0 ? (
                reportList?.map(({ id, scheduledEmailsCount, sentEmailsCount,
                  month, year, user, userId, documentLink
                }, index) => {

                  return (
                    <tr key={index} className="report-table-row">
                      {!recruiterDetailPage ? <td >
                        <span className="">
                          {user?.fullName}
                        </span>
                      </td> : ''
                      }
                      <td>
                        <span className=''>
                          {moment().month(parseInt(month) - 1).format('MMMM')}
                        </span>
                      </td>

                      <td>
                        <span className=''>
                          {year}
                        </span>
                      </td>

                      <td>
                        <span className='d-flex justify-center gap-14'>
                          <div>
                            <img src={SEND_NOW_ICON} alt="sent" />
                            <span className="mx-2">{sentEmailsCount}</span>
                          </div>
                          <div>
                            <img src={SCHEDULED_ICON} alt="sent" width="18px" />
                            <span className="mx-2">{scheduledEmailsCount}</span>
                          </div>
                        </span>
                      </td>


                      <td>
                        <div className="d-flex justify-center gap-14">
                          {!recruiterDetailPage && <Button
                            onClick={() => {
                              if (id && user && documentLink)
                                setSingleReport({
                                  id, month, year, userId, fullName: user?.fullName,
                                  documentLink, email: user?.email
                                })
                              setEditableBody(undefined)
                              setEmailReportModal(true)
                            }}
                            className="btn bg-transparent p-0 border-0">
                            <img
                              src={EMAIL_ICON}
                              alt="email"
                              width="18px"
                            />
                          </Button>}

                          <Button
                            onClick={() => {
                              if (documentLink) {
                                viewReport(documentLink, documentLink.match(/\/([^\/]+)$/)![1].split('-')[1])
                              }
                            }}
                            disabled={documentLink ? false : true}
                            className={recruiterDetailPage ? 'btn bg-transparent p-0 border-0 ml-3' : "btn bg-transparent p-0 border-0"}
                          >
                            <img src={VIEW_ICON} alt="delete" />
                          </Button>


                          {!recruiterDetailPage &&
                            <>
                              <Button
                                onClick={() => {
                                  setEditAble(true)
                                  setAddReportModal(true)
                                  if (id && user && documentLink)
                                    setSingleReport({ id, month, year, userId, fullName: user?.fullName, documentLink })
                                }
                                }
                                className="btn bg-transparent p-0 border-0"
                              >
                                <img src={EDIT_ICON} alt="edit" />
                              </Button>

                              <Button
                                onClick={() => {
                                  setConfirmDeletion(!confirmDeletion)
                                  if (id && user && documentLink)
                                    setSingleReport({ id, month, year, userId, fullName: user?.fullName, documentLink })
                                }}
                                className="btn bg-transparent p-0 border-0"

                              >
                                <img src={DELETE_ICON} alt="delete" />
                              </Button>
                            </>
                          }
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={ACTIVITY_REPORTS_HEADER(recruiterDetailPage).length}
                    className="empty-table-td"
                  >
                    <NoDataFound text="No Reports Found!" />
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </TableComponent>
      </div>

      {!loading && !!data?.userActivityReports?.userActivityReports?.length && !recruiterDetailPage &&
        <div className="users-pagination" >
          <Pagination
            onPageChange={(pageClicked: number) => {
              setCurrentPage(pageClicked);
            }} currentPage={currentPage}
            pageCount={Math.ceil(data?.userActivityReports?.count / limit)}
          />
          <div className="d-flex align-items-center">
            <div className="pagination-display paginationItemsSelect">
              <p className="m-0">
                {(currentPage - 1) * limit + 1} to{' '}
                {Math.min(
                  currentPage * limit,
                  data?.userActivityReports?.count
                )}
                {` of `} {data?.userActivityReports?.count}
              </p>

              <div className="divider"></div>
              <label>Display</label>
              <InputField
                label=""
                inputtype="select"
                selectItems={PAGE_LIMIT.filter((item) => item.value !== limit)}
                inputid="limit"
                placeholder={limit.toString()}
                inputMethod={(value) => {
                  setCurrentPage(1);
                  setLimit(parseInt(value));
                }}
              />
            </div>
          </div>
        </ div>
      }

      <h5 className="m-0 mt-4">{SCHEDULED_EMAILS}</h5>

      <div className="table-responsive mt-3">
        <TableComponent
          tableHeader={SCHEDULED_EMAILS_HEADERS}>

          {loadingScheduledEmails ? (
            <tbody>
              <tr>
                <td colSpan={SCHEDULED_EMAILS_HEADERS?.length}>
                  <Loader loaderClass="sm-height " />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody >
              {scheduledEmailsList?.length > 0 ? (
                scheduledEmailsList?.map(({
                  id, scheduledDate, emailStatus, emailBodyJSON,
                  activityReport: { month, year, user }, updatedAt }, index) => {
                  const emailBody = JSON.parse(emailBodyJSON)
                  return (
                    <tr key={index} className="report-table-row">
                      <td>{formatDateUS(updatedAt!) || "--"}</td>
                      <td>{moment(Number(scheduledDate)).utcOffset(0).format('MM/DD/YYYY') || "--"}</td>
                      {!recruiterDetailPage ? <td className="">
                        <span className="">
                          {user?.fullName}
                        </span>
                      </td> : ''
                      }
                      <td>
                        <span className=''>
                          {moment().month(parseInt(month) - 1).year(parseInt(year)).format('MMM-YY')}
                        </span>
                      </td>

                      <td className='badge-pading'>
                        <div style={{ width: 120 }}>
                          <Badge
                            color={emailStatus === 'Sent' ? 'success' : 'primary'}
                            className="text-capitalize"
                          >{emailStatus}
                          </Badge>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex justify-center gap-14" style={{ width: 110 }}>
                          {!recruiterDetailPage && <Button
                            onClick={() => {
                              setEditableBody({ ...emailBody, toContact: user?.email, scheduledDate, scheduledId: id })
                              setSingleReport(undefined)
                              setEmailReportModal(true)
                            }}
                            disabled={emailStatus === 'Sent'}
                            className="btn bg-transparent p-0 border-0">
                            <img
                              src={EDIT_ICON}
                              alt="edit"
                            />
                          </Button>}

                          <Button
                            onClick={() => {
                              setDeleteScheduledRecord(id)
                              setConfirmDeletion(!confirmDeletion)
                            }}
                            disabled={emailStatus === 'Sent'}
                            className="btn bg-transparent p-0 border-0"

                          >
                            <img src={DELETE_ICON} alt="delete" />
                          </Button>

                          <SendNowButton variables={{ id }} refetch={() => {
                            refetchScheduledEmails()
                            refetch()
                          }} sent={emailStatus === 'Sent'} />

                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={SCHEDULED_EMAILS_HEADERS.length}
                    className="empty-table-td"
                  >
                    <NoDataFound text="No Scheduled Emails Found!" />
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </TableComponent>
      </div>

      {!loadingScheduledEmails && !!dataScheduledEmails?.scheduledActivityReportEmails?.count &&
        <div className="users-pagination" >
          <Pagination
            onPageChange={(pageClicked: number) => {
              setScheduledCurrentPage(pageClicked);
            }} currentPage={scheduledCurrentPage}
            pageCount={Math.ceil(dataScheduledEmails?.scheduledActivityReportEmails?.count / scheduledLimit)}
          />
          <div className="d-flex align-items-center">
            <div className="pagination-display paginationItemsSelect">
              <p className="m-0">
                {(scheduledCurrentPage - 1) * scheduledLimit + 1} to{' '}
                {Math.min(
                  scheduledCurrentPage * scheduledLimit,
                  dataScheduledEmails?.scheduledActivityReportEmails?.count)}
                {` of `} {dataScheduledEmails?.scheduledActivityReportEmails?.count}
              </p>

              <div className="divider"></div>
              <label>Display</label>
              <InputField
                label=""
                inputtype="select"
                selectItems={PAGE_LIMIT.filter((item) => item.value !== scheduledLimit)}
                inputid="limit"
                placeholder={scheduledLimit.toString()}
                inputMethod={(value) => {
                  setScheduledCurrentPage(1);
                  setScheduledLimit(parseInt(value));
                }}
              />
            </div>
          </div>
        </ div>
      }

      <AddActivityReportModal
        edit={editAble} activityReport={singleReport}
        isOpen={addReportModal} refetch={refetch}
        toggle={() => {
          setAddReportModal(!addReportModal)
          setEditAble(false)
        }}
      />
      <EmailModalActivityReport
        activityReport={singleReport}
        ccContact={!loadingEmail && emailData?.getUserManagerEmail}
        isOpen={!loadingEmail && emailReportModal}
        editableBody={editableBody}
        refetchList={() => {
          refetchScheduledEmails()
          refetch()
        }}
        toggle={() => setEmailReportModal(!emailReportModal)} />
      <ConfirmPopUp
        isOpen={confirmDeletion}
        toggle={() => setConfirmDeletion(!confirmDeletion)}
        modalHeading="Delete Record"
        loading={deleting || deletingScheduledReport}
        disabled={deleting || deletingScheduledReport}
        confirmText="Are you sure you want to delete this record?"
        confirmAction={async () => {
          if (deleteScheduledRecord) {
            await deleteScheduledReport({ variables: { id: deleteScheduledRecord } })
            return
          }
          const activityReport = await deleteReport({ variables: { id: singleReport?.id } })
          if (activityReport?.data?.removeUserActivityReport?.status === 200) {
            toast.success('deleted successfully')
            setConfirmDeletion(!confirmDeletion)
            refetch()
            return
          }
          toast.error("unable to delete")
        }} />
      <Modal
        isOpen={viewDocument}
        toggle={() => setViewDocument(!viewDocument)}
        centered={true}
        size="xl"
        className="revampDialog border-0"
      >
        <div className="pdf-viewer">
          <Preview
            documentUrl={documentUrl}
            documentName={`${documentName}.pdf`}
            isDownload={true}
          />
        </div>
      </Modal>
    </>
  )
}

export default UserActivityReports;